import { MARKDOWN_SEPARATOR } from '../../types';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';
import React from 'react';

export const SimpleClientTextMessage = (props: { content: string | null }) => {
  const { content } = props;
  if (!content) return null;
  const markdownSeparatorStart = content.indexOf(MARKDOWN_SEPARATOR);
  if (markdownSeparatorStart < 0) return <>{content}</>;
  const markdownSeparatorEnd = markdownSeparatorStart + MARKDOWN_SEPARATOR.length;
  return (
    <>
      {content.substring(0, markdownSeparatorStart)}
      <Markdown
        className="message-list__message-ai-sub-content markdown-container"
        remarkPlugins={[remarkGfm]}
      >
        {content.substring(markdownSeparatorEnd)}
      </Markdown>
    </>
  );
};
